import React, { Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const OneTrust = lazy(() => import("../PrivacyPolicy"));
const AU = lazy(() => import("../Australia/PrivacyPolicyAU"));
const DK = lazy(() => import("../Denmark/PrivacyPolicy/PrivacyPolicyDK"));
const PT = lazy(() => import("../Portugal/PrivacyPolicy/PrivacyPolicyPT"));

const PrivacyPolicyLoader = () => {
    const region = useSelector((state: RootState) => state.region.region);

    return (
        <Suspense fallback={<Spinner animation="border" variant="light" />}>
            {region === "AU" ? (
                <AU />
            ) : region === "DK" ? (
                <DK />
            ) : region === "PT" ? (
                <PT />
            ) : (
                <OneTrust />
            )}

        </Suspense>
    )

}

export default PrivacyPolicyLoader;
